import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invert-mode-sharp",
  "use": "icon-invert-mode-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-invert-mode-sharp\"><title>Invert Mode</title><path d=\"M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 432v-96a80 80 0 010-160V80c97.05 0 176 79 176 176s-78.95 176-176 176z\" /><path d=\"M336 256a80 80 0 00-80-80v160a80 80 0 0080-80z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol